import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
  Box,
  Pagination,
  Typography, Divider, useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getLogsLoginAPI } from 'apis/logs/logsAPI';
import dayjs from 'dayjs';

// 공통 타입
type User = {
  id: number;
  email: string;
  username: string;
  name: string;
  phoneNumber: string;
  userType: string | null;
  type: string; // e.g., "NATIVE"
};

type Log = {
  id: number;
  ip: string;
  platform: string; // e.g., "Mac OS X/Mac/Chrome"
  userAgent: string; // Full User-Agent string
  requestedAt: string; // ISO date string
  name: string; // Action name, e.g., "login", "updateNotice"
  action: string; // e.g., "LOGIN", "UPDATE", "DELETE"
  httpMethod: string; // e.g., "POST", "PUT", "DELETE"
  api: string; // API endpoint
  body: string; // Request body
  user: User; // Associated user
};

export default function HistoryUser() {
  const [logs, setLogs] = useState<Log[]>([]);
  const theme = useTheme();
  // 다국어
  const { t, i18n } = useTranslation(); // useTranslation 훅 사용

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // 페이지 변경 핸들러
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => setPage(value);

  // 로그 불러오기
  const fetchNotices = async () => {
    try {
      const response = await getLogsLoginAPI({ page: page });

      setLogs(response.data.logs);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching notices:', error);
    }
  };
  // 언어 바뀔때, 공지사항 불러오기
  useEffect(() => {
    fetchNotices();
  }, [i18n.language, page]);

  return (
    <>
      <Box sx={{ padding: 2 }}>
        <Box
          borderRadius={1}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h5" fontWeight="bold">
            {t('menu.history.user')}
          </Typography>

          <Divider flexItem />
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: theme.palette.contentBlock.background }}>
                <TableCell width="15%" sx={{ fontWeight: 'bold' }}>시간</TableCell>
                <TableCell width="10%" sx={{ fontWeight: 'bold' }}>아이디</TableCell>
                <TableCell width="10%" sx={{ fontWeight: 'bold' }}>이름</TableCell>
                <TableCell width="15%" sx={{ fontWeight: 'bold' }}>이메일</TableCell>
                <TableCell width="10%" sx={{ fontWeight: 'bold' }}>IP</TableCell>
                <TableCell width="15%" sx={{ fontWeight: 'bold' }}>플랫폼</TableCell>
              </TableRow>
            </TableHead>
            {logs && (
              <TableBody>
                {logs.map((log) => (
                  <TableRow key={log.id}>
                    <TableCell>{new Date(log.requestedAt).toLocaleString()}</TableCell>
                    <TableCell>{log.user?.username || '알 수 없음'}</TableCell>
                    <TableCell>{log.user?.name || '알 수 없음'}</TableCell>
                    <TableCell>{log.user?.email || '알 수 없음'}</TableCell>
                    <TableCell>{log.ip}</TableCell>
                    <TableCell>{log.platform}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
      <Box mt={2} mb={4} display="flex" justifyContent="center">
        <Pagination count={totalPages} page={page} onChange={handlePageChange} color="primary" />
      </Box>
    </>
  );
}
